

function SvgIcon({color}) {
    return <svg className="dotvector" width="105" height="96" viewBox="0 0 105 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="2.5" cy="20.4379" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="2.5" cy="56.7717" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="2.5" cy="93.1056" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="2.5" cy="2.27087" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="2.5" cy="38.6047" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="2.5" cy="74.9386" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="22.5" cy="20.4379" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="22.5" cy="56.7717" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="22.5" cy="93.1056" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="22.5" cy="2.27087" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="22.5" cy="38.6047" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="22.5" cy="74.9386" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="42.5" cy="20.4379" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="42.5" cy="56.7717" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="42.5" cy="93.1056" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="42.5" cy="2.27087" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="42.5" cy="38.6047" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="42.5" cy="74.9386" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="62.5" cy="20.4379" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="62.5" cy="56.7717" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="62.5" cy="93.1056" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="62.5" cy="2.27087" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="62.5" cy="38.6047" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="62.5" cy="74.9386" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="82.5" cy="20.4379" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="82.5" cy="56.7717" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="82.5" cy="93.1056" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="82.5" cy="2.27087" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="82.5" cy="38.6047" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="82.5" cy="74.9386" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="102.5" cy="20.4379" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="102.5" cy="56.7717" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="102.5" cy="93.1056" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="102.5" cy="2.27087" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="102.5" cy="38.6047" rx="2.5" ry="2.27087" fill={color} />
        <ellipse cx="102.5" cy="74.9386" rx="2.5" ry="2.27087" fill={color} />
    </svg>
}
export default SvgIcon;